define('responsive-pitch-fx/lib/PitchLayer',['require','exports','module','./render/Canvas','./render/Dom','./helpers/Scaler','./workers/Pitch','./workers/Scheduler','./enums/config','./helpers/merge','./helpers/cssClass'],function(require,exports,module){
    var RenderCanvas= require( './render/Canvas' ),
        RenderDom   = require( './render/Dom' ),
        Scaler      = require( './helpers/Scaler' ),
        Pitch       = require( './workers/Pitch' ),
        Scheduler   = require( './workers/Scheduler' ),
        config      = require( './enums/config' ),
        merge       = require( './helpers/merge' ),
        cssClass    = require( './helpers/cssClass' );


    function PitchLayer(options){ 

        if(!(this instanceof PitchLayer)){
            return PitchLayer.create(options);
        }
        this.teams={};

        this.scale();
        this.pitches=[];
        this.pitchGrid=[];
        this.config=merge({},config,options);
        this.render=new RenderCanvas(this);
        this.dom=new RenderDom(this);
        this.scheduler = new Scheduler();
        if(this.type==='side'){
            this.viewAngle=90;
        }

        this.atbat={}
        this.lastAtbat={};

    };

    PitchLayer.create = function(type){
        return new PitchLayer(type);
    };

    /**
     * Configure all instances of PitchLayer
     * @param  {object}     opts    Config properties to apply to 
     *                              all instances of PitchLayer
     * @see  ../enums/config.js
     * @return {object}             All configured options.
     */
    PitchLayer.config = function (opts) {
        merge(config,opts);
        return config;
    };

    PitchLayer.prototype={
        view        : null,
        viewAngle   : 0,
        anchored    : false,
        drawn       : false,
        fetched     : false,
        pitchCount  : 0,
        refreshOnBeat : false,

        pitchIds    : "",
        isStrikeZoneDrawn : false,
        hidden      : true,


        scale  : function (w) {
            this.scalers=new Scaler(w);
            if(this.render){
                this.render.scalers=this.scalers;
            }
            if(this.dom){
                this.dom.scalers=this.scalers;
                // this.dom.sizer.style.minHeight=this.scalers.minHeight+'%';
            }

            return this.scalers;
        },
        drawBall : function(p, pt){
            this.render.drawBall(p, pt);
            this.dom.drawBall(p, pt);
        },

        ensurePitches: function(){
            var pitches=[],
                pitchesOrAtbat=this.atbat;

            if(pitchesOrAtbat.pitches){
                pitches=pitches.concat(pitchesOrAtbat.pitches);
            }else if(!Array.isArray(pitchesOrAtbat)){
                if(pitchesOrAtbat.isPitch){
                    pitches=pitches.concat(pitchesOrAtbat);
                }
            }
            this.pitches=pitches;
            return pitches;
        },

        ensureBatter: function(){
            return this.atbat.batter !== this.lastAtbat.batter || 
            this.atbat.stand !== this.lastAtbat.stand
        },

        parsePitches : function(){
            if(!this.atbat || this.atbat.num!==this.lastAtbat.num){
                this.clearAtbat();
            }
            this.ensurePitches();
        },
        draw2Dpitch : function(){
            this.render.draw2Dpitch();
        },

        draw3dPitch : function(){
            this.render.drawPitch();
        },

        clearAtbat : function(){
            this.clearPitches();
            this.isStrikeZoneDrawn = false;
            this.scheduler.clear();
        },

        clearPitches: function() {
            this.pitchIds = "";
            this.render.clear();
            this.dom.clear();
        },

        clearAll : function () {

            this.atbat = {};
            this.lastAtbat={};

            this.clearAtbat();
        },

        resize : function () {
            var w;
            if (this.view) {
                w = this.dom.sizer.offsetWidth * this.scalers.canvasDensity;

                if(this.scalers.width < ~~w){
                    this.scale(w);
                    this.render.resize();
                    this.dom.resize();
                    this.render.resize();
                }
            }
        },

        anchor : function (view) {
            var that=this;
            if (this.view!==view && !this.anchored) {
                this.view=view;
                this.view.className += " " + cssClass() 
                    + (this.config.tiltShift ? " " + cssClass("tilt-shift") : "")
                    + (this.config.oldTimey ? " " + cssClass("old-timey") : "");
                this.anchored = true;
                this.clearAll();
                that.dom.anchor();
                that.render.anchor();
            }
            return this;
        },

        isDrawn: function () {
            return this.anchored && this.drawn;
        },

        draw: function (atbat,hotcold,clear) {
            // this.anchor();
            if(typeof hotcold==='boolean'){
                clear=hotcold;
                hotcold=null;
            }
            if(clear){
                this.clearAll();
            }
            this.resize();
                // stash this
            this.lastAtbat=this.atbat;
                //update the reference
            this.atbat=atbat||this.atbat;
            this.hotcold=hotcold;
            if(this.ensureBatter()){
                this.dom.drawBatter();
            }
            this.parsePitches();
            this.drawPitches();

            return this;
        },

        drawPitches : function(){
            // might be a fat lotta nuthin'
            var that=this,
                pitches=that.pitches,
                i=0,
                len=pitches.length;

            if (len === 0) {
                return;
            }
            var pitchIds=this.pitchIds;

            for(; i < len; i++){
                if (pitchIds.indexOf(pitches[i].id) === -1) {  //see if pitch drawn already
                    var pitch = new Pitch(pitches[i],this.render);
                    this.pitchIds += pitch.pitch.id + ", ";
                    that.render.drawHistory();
                    that.render.drawPitch(pitch);
                }
            }

            this.scheduler.run();
            this.pitches=[];
        },

        render : function (pitches, pctr, atbat) {
            this.render.render();
        },

        destroy: function (keep) {
            this.clearAll();
            if (keep !== true) {
                this.render.destroy();
                this.dom.destroy();
            }
            this.anchored = false;
            this.drawn = false;

        }
    };

    return PitchLayer;
});
